export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login gagal, silakan coba lagi.",
  requestFailed: "Permintaan gagal, periksa koneksi internet Anda.",
  invalidLogin: "Nama pengguna atau kata sandi tidak valid.",
  thisFunctionExists: "Fungsi ini sudah ada.",
  thisFunctionNotAllowDelete: "Fungsi ini tidak boleh dihapus.",
  thisFunctionNotExists: "Fungsi ini tidak ada.",
  targetFunctionIdRequired: "ID Fungsi Target diperlukan.",
  thisPageExists: "Halaman ini sudah ada.",
  thisPageNotAllowDelete: "Halaman ini tidak boleh dihapus.",
  thisRoleExists: "Peran ini sudah ada.",
  thisRoleNotAllowDelete: "Peran ini tidak diizinkan untuk dihapus.",
  targetRoleIdRequired: "ID Peran Target harus diisi.",
  invalidParameter: "Parameter tidak valid.",
  systemError: "Sistem tidak dapat memproses permintaan Anda.",
  spErrorMessage: "Kesalahan Pesan SP (Tergantung kesalahan apa).",
  actionbyRequired: "Pengguna saat ini diperlukan.",
  sessionTokenRequired: "Token Sesi diperlukan.",
  functionIdRequired: "ID Fungsi diperlukan.",
  functionNameRequired: "Nama fungsi diperlukan.",
  newFunctionNameRequired: "Nama fungsi diperlukan.",
  pageIdRequired: "ID halaman diperlukan.",
  newPageIdRequired: "ID halaman diperlukan.",
  newPageNameRequired: "Nama halaman diperlukan.",
  targetPageIdRequired: "ID Halaman Target diperlukan.",
  passwordRequired: "Kata sandi diperlukan.",
  userNameRequired: "Nama lengkap harus diisi.",
  passwordValidation: "Kata sandi harus terdiri dari 6-20 karakter dan merupakan kombinasi angka dan huruf.",
  pageNumRequired: "Nomor Halaman harus diisi.",
  pageSizeRequired: "Ukuran Halaman harus diisi.",
  roleIdRequired: "ID Peran diperlukan",
  oldPasswordRequired: "Kata Sandi Saat Ini diperlukan.",
  userStatusRequired: "Status Pengguna diperlukan.",
  newRoleIdRequired: "ID Peran diperlukan.",
  newRoleNameRequired: "Nama Peran harus diisi.",
  startDateIsGteEndDate: "Tanggal Mulai lebih besar dari Tanggal Akhir.",
  thisRoleNotExists: "Peran ini tidak ada.",
  thisPageNotExists: "Halaman ini tidak ada.",
  thisUserExists: "Pengguna ini sudah ada.",
  thisUserNotExists: "Pengguna ini tidak ada.",
  thisUserBlackListed: "Akun Anda telah ditangguhkan.",
  thisUserInactive: "Akun Anda telah dinonaktifkan.",
  thisUserBlocked: "Akun Anda telah diblokir.",
  thisUserNotActive: "Akun Anda telah dinonaktifkan.",
  InvalidPageFunction: "Fungsi Halaman Tidak Valid.",
  invalidUser: "Pengguna Tidak Valid!",
  invalidToken: "Sesi Tidak Valid!",
  NoUserAccessRight: "Izin Ditolak!",
  connection: "Kesalahan koneksi",
  profileIdRequired: "ID Profil diperlukan.",
  packageIdRequired: "ID Paket diperlukan.",
  fullNameMinThreeChar: "Nama lengkap harus terdiri dari minimal 3 karakter.",
  accountIdMinThreeChar: "ID Akun harus memiliki minimal 3 karakter.",
  searchCriteriaRequired: "Kriteria pencarian diperlukan.",
  affiliateIdRequired: "Id Afiliasi diperlukan",
  minDepositRequired: "Diperlukan setoran minimum.",
  bonusRateRequired: "Tingkat Bonus diperlukan.",
  onlyAllowRejectDeposit: "Hanya mengizinkan untuk menolak tiket deposit.",
  senderBankIdRequired: "ID bank pengirim diperlukan.",
  senderBankAccNoRequired: "Nomor rekening bank pengirim diperlukan.",
  minFTDAmtNumOnly: "Min. FTD Amt hanya menerima angka.",
  maxFTDAmtNumOnly: "Maks. FTD Amt hanya menerima angka.",
  crmBasicCriteriaRequired: "ID Anggota / Telepon Kontak / Email Kontak / Tanggal Pendaftaran / Tanggal Login Terakhir diperlukan.",
  verifiedDateRangeAllowThreeMonths: "Rentang tanggal pendaftaran hanya mengizinkan pemilihan hingga 3 bulan.",
  lastLoginDateRangeAllowThreeMonths: "Rentang tanggal Login Terakhir hanya mengizinkan pemilihan hingga 3 bulan.",
  depositDateRangeAllowThreeMonths: "Rentang tanggal deposit hanya mengizinkan pemilihan hingga 3 bulan.",
  ftdDateRangeAllowThreeMonths: "Rentang tanggal FTD hanya mengizinkan pemilihan hingga 3 bulan.",
  ltdDateRangeAllowThreeMonths: "Rentang tanggal LTD hanya mengizinkan pemilihan hingga 3 bulan.",
  lastLoginDateEarlierThanVerifiedDate: "Tanggal Login terakhir lebih awal dari tanggal pendaftaran.",
  depositDateEarlierThanVerifiedDate: "Tanggal deposit lebih awal dari tanggal pendaftaran.",
  ftdDateEarlierThanVerifiedDate: "Tanggal FTD lebih awal dari tanggal pendaftaran.",
  ltdDateEarlierThanVerifiedDate: "Tanggal LTD lebih awal dari tanggal pendaftaran.",
  ftdFromRequired: "FTD dari tanggal diperlukan.",
  ftdToRequired: "FTD sampai tanggal diperlukan.",
  ltdFromRequired: "LTD dari tanggal diperlukan.",
  ltdToRequired: "LTD hingga tanggal diperlukan.",
  failedToLaunchPaymentGateway: "Gagal meluncurkan gateway pembayaran.",
  enTitleRequired: "EN Judul diperlukan.",
  enBodyRequired: "EN Badan diperlukan.",
  enImageUrlRequired: "EN Url Gambar diperlukan.",
  enImageUrlDesktopRequired: "EN Url Gambar Desktop diperlukan.",
  enAltRequired: "EN Alt diperlukan.",
  enHrefRequired: "EN Href diperlukan.",
  resubmitTicketRequired: "Diperlukan pengiriman ulang tiket.",
  withtholdBonusAndAmountGreaterThanZero: "Withhold bonus dan jumlah pemotongan tidak boleh lebih besar dari nol pada saat yang bersamaan.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Maksimal penarikan dan jumlah penarikan tidak boleh lebih besar dari nol secara bersamaan.",
  serverBusy: "Server sedang sibuk sekarang. Silakan coba lagi.",
  isRequired: "Silakan masukkan {fname}.",
  isMinValue: "{fname} harus memiliki minimal {fvalue}.",
  isMaxValue: "{fname} harus kurang dari atau sama dengan {fvalue}.",
  isMinLength: "{fname} harus memiliki setidaknya {fvalue} karakter.",
  isMaxLength: "{fname} harus kurang dari atau sama dengan karakter {fvalue}.",
  isAlpha: "{fname} hanya menerima alfabet.",
  isAlphaNum: "{fname} hanya menerima alfanumerik.",
  isNumeric: "{fname} hanya menerima angka.",
  isEmail: "{fname} hanya menerima alamat email yang valid.",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang valid.",
  isSameAs: "{fname} harus sama dengan {fname2}.",
  isUrl: "{fname} hanya menerima URL.",
  containAlphaNum: "{fname} harus memiliki setidaknya satu alfabet dan satu angka.",
  alphaNumWithSpace: "{fname} hanya menerima alfanumerik.",
  isDecimal: "{fname} hanya menerima angka.",
  isInteger: "{fname} hanya menerima bilangan bulat.",
  selectOption: "Silakan pilih {fname}",
  notSameAs: "{fname} dan {fname2} tidak boleh sama.",
  dateRangeAllowOneMonth: "Rentang tanggal hanya mengizinkan pemilihan hingga 1 bulan.",
  dateRangeAllowOneYear: "Rentang tanggal hanya mengizinkan pemilihan hingga 1 tahun.",
  greaterThanZero: "{fname} harus lebih besar dari nol.",
  atLeastOneAuthority: "Harus memilih setidaknya satu otoritas.",
  BLOCK: "Akun Anda telah diblokir.",
  SUSPEND: "Akun Anda telah ditangguhkan.",
  CLOSE: "Akun Anda telah ditutup.",
  RESETL: "Akun Anda telah diatur ulang.",
  atLeastOneProvider: "Harus memilih setidaknya satu penyedia.",
  failedToGetResultUrl: "Gagal mendapatkan url hasil.",
  fileSizeValidation: "Terlalu besar, ukuran maksimal yang diperbolehkan adalah 1mb",
  atLeastOnePaymentOption: "Harus memilih setidaknya satu opsi pembayaran.",
  atLeastOnePaymentGateway: "Harus memilih setidaknya satu gateway pembayaran.",
  dateRangeAllow31Days: "Rentang tanggal hanya mengizinkan pemilihan hingga 31 hari.",
  dateRangeAllow31Months: "Rentang tanggal hanya mengizinkan pemilihan hingga 31 bulan.",
  dateRangeAllow31Years: "Rentang tanggal hanya mengizinkan pemilihan hingga 31 tahun.",
  invalidCategory: "Kategori tidak valid.",
  noChanges: "Tidak ada perubahan.",
  permissionDenied: "Izin ditolak.",
  referralCodeRequired: "Kode rujukan diperlukan.",
  providerDescRequired: "Deskripsi penyedia diperlukan.",
  marqueeContentRequired: "Konten tenda diperlukan.",
  bonusNameRequired: "Nama bonus diperlukan.",
  baseAmountRequired: "Jumlah dasar diperlukan.",
  reviewIdRequired: "ID ulasan diperlukan.",
  surveyIdRequired: "ID survei diperlukan.",
  questionRequired: "Pertanyaan diperlukan.",
  iframeIdRequired: "ID Iframe diperlukan.",
  bonusAmountRequired: "Jumlah bonus diperlukan.",
  inboxIdRequired: "ID kotak masuk diperlukan.",
  exchangedAmountRequired: "Jumlah yang ditukar diperlukan.",
  baseRateRequired: "Kurs dasar diperlukan.",
  exchangeRateRequired: "Nilai tukar diperlukan.",
  baseCurrencyRequired: "Mata uang dasar diperlukan.",
  exchangeCurrencyRequired: "Mata uang yang ditukarkan wajib diisi.",
  depositTypeRequired: "Jenis deposit diperlukan.",
  nbRedepositRequired: "Diperlukan setoran ulang Nb.",
  bankOwnerRequired: "Pemilik bank diperlukan.",
  autoSenderRequired: "Pengirim otomatis diperlukan.",
  isRecommendRequired: "Direkomendasikan diperlukan.",
  recipientBankIdRequired: "ID bank penerima diperlukan.",
  recipientBankAccNoRequired: "Nomor rekening bank penerima diperlukan.",
  accountBalanceRequired: "Saldo rekening diperlukan.",
  incomingAmountThresholdRequired: "Ambang batas jumlah yang masuk diperlukan.",
  incomingFrequencyThresholdRequired: "Ambang batas frekuensi masuk diperlukan.",
  outgoingAmountThresholdRequired: "Ambang batas jumlah keluar diperlukan.",
  outgoingFrequencyThresholdRequired: "Ambang batas frekuensi keluar diperlukan.",
  bankAccTypeRequired: "Jenis rekening bank diperlukan.",
  packageRequired: "Paket diperlukan.",
  rtpRequired: "RTP diperlukan.",
  domainIdRequired: "ID domain diperlukan.",
  buyOnBehalfRequired: "Beli atas nama diperlukan.",
  serviceProviderRequired: "Penyedia layanan diperlukan.",
  serverAccountRequired: "Akun server diperlukan.",
  nameServerRequired: "Server nama diperlukan.",
  socialLinkRequired: "Tautan sosial diperlukan.",
  newSocialPlatformRequired: "Diperlukan platform sosial baru.",
  attachmentPathRequired: "Jalur lampiran diperlukan.",
  depositMethodRequired: "Metode deposit diperlukan.",
  depositDateRequired: "Tanggal penyetoran diperlukan.",
  refNoRequired: "Nomor referensi diperlukan.",
  withdrawalAmountRequired: "Jumlah penarikan diperlukan.",
  targetBankAccNoRequired: "Nomor rekening bank target diperlukan.",
  targetBankIdRequired: "ID bank target diperlukan.",
  jsonRatingRequired: "Peringkat JSON diperlukan.",
  startTimeRequired: "Waktu mulai diperlukan.",
  accountIdRequired: "ID akun diperlukan.",
  parentIdRequired: "ID orang tua diperlukan.",
  amountRequired: "Jumlah diperlukan.",
  clientIpRequired: "IP klien diperlukan.",
  auditByRequired: "Audit oleh diperlukan.",
  systemTypeRequired: "Jenis sistem diperlukan.",
  currencyRequired: "Mata uang diperlukan.",
  ipAddressRequired: "Alamat IP diperlukan.",
  affiliateCodeRequired: "Kode afiliasi diperlukan.",
  contactPhoneRequired: "Kontak telepon diperlukan.",
  requestTypeRequired: "Jenis permintaan diperlukan.",
  securityDisabledRequired: "Keamanan dinonaktifkan diperlukan.",
  gameCodeRequired: "Kode permainan diperlukan.",
  seqRequired: "Urutan diperlukan.",
  minLimitRequired: "Batas minimum diperlukan.",
  maxLimitRequired: "Batas maksimum diperlukan.",
  commSportsRequired: "Komisi untuk olahraga diperlukan.",
  commSlotsRequired: "Komisi untuk slot diperlukan.",
  commLivecasinoRequired: "Komisi untuk kasino langsung diperlukan.",
  commCockfightRequired: "Komisi untuk sabung ayam diperlukan.",
  commOthersRequired: "Komisi untuk orang lain diperlukan.",
  settingValueRequired: "Nilai pengaturan diperlukan.",
  vipIdRequired: "ID VIP diperlukan.",
  carryOverRequired: "Carry over diperlukan.",
  campaignIdRequired: "ID kampanye diperlukan.",
  titleRequired: "Judul diperlukan.",
  bodyRequired: "Diperlukan badan.",
  itemOrderRequired: "Urutan barang diperlukan.",
  imageUrlRequired: "URL gambar diperlukan.",
  bannerIdRequired: "ID spanduk diperlukan.",
  directionRequired: "Arah diperlukan.",
  defaultOrderRequired: "Urutan default diperlukan.",
  altRequired: "Alt text diperlukan.",
  hrefRequired: "Href diperlukan.",
  targetWindowRequired: "Jendela target diperlukan.",
  loginRequiredRequired: "Login diperlukan.",
  activeFromRequired: "Aktif dari diperlukan.",
  activeToRequired: "Aktif ke diperlukan.",
  bannerTypeRequired: "Jenis spanduk diperlukan.",
  pageNameRequired: "Nama halaman diperlukan.",
  remarkRequired: "Keterangan diperlukan.",
  settingKeyRequired: "Kunci pengaturan diperlukan.",
  memberListRequired: "Daftar anggota diperlukan.",
  memberIdRequired: "ID anggota diperlukan.",
  workingMonthRequired: "Bulan kerja diperlukan.",
  workingDateRequired: "Tanggal kerja diperlukan.",
  tacRequired: "Syarat dan ketentuan diperlukan.",
  paymentModeRequired: "Mode pembayaran diperlukan.",
  newPasswordRequired: "Kata sandi baru diperlukan.",
  loginIdRequired: "ID login diperlukan.",
  securityTagRequired: "Tag keamanan diperlukan.",
  securityCodeRequired: "Kode keamanan diperlukan.",
  providerCodeRequired: "Kode penyedia diperlukan.",
  startDateRequired: "Tanggal mulai diperlukan.",
  endDateRequired: "Tanggal akhir diperlukan.",
  searchIdRequired: "ID pencarian diperlukan.",
  authTokenRequired: "Token autentik diperlukan.",
  newStatusRequired: "Status baru diperlukan.",
  actionRequired: "Tindakan diperlukan.",
  promotionIdRequired: "ID promosi diperlukan.",
  promotionNameRequired: "Nama promosi diperlukan.",
  rolloverRequired: "Rollover diperlukan.",
  criteriaRequired: "Kriteria diperlukan.",
  ticketIdRequired: "ID tiket diperlukan.",
  resultIdRequired: "ID Hasil diperlukan.",
  bankIdRequired: "ID Bank diperlukan.",
  bankAccNoRequired: "Nomor rekening bank diperlukan.",
  bankAccHolderRequired: "Pemegang rekening bank diperlukan.",
  newBankIdRequired: "ID bank baru diperlukan.",
  newBankAccNoRequired: "Nomor rekening bank baru diperlukan.",
  newBankAccHolderRequired: "Pemegang rekening bank baru diperlukan.",
  fullNameRequired: "Nama lengkap diperlukan.",
  depositAmountRequired: "Jumlah deposit diperlukan.",
  gatewayAccRequired: "Akun gateway diperlukan.",
  labelNameRequired: "Nama label diperlukan.",
  labelIdRequired: "ID label diperlukan.",
  bankTypeRequired: "Jenis bank diperlukan.",
  amountLimitRequired: "Batas jumlah diperlukan.",
  currencyRateRequired: "Kurs mata uang diperlukan.",
  urlRequired: "URL wajib diisi.",
  cashRequired: "Diperlukan uang tunai.",
  csRequired: "Dukungan pelanggan diperlukan.",
  vipNameRequired: "Nama VIP diperlukan.",
  campaignNameRequired: "Nama kampanye diperlukan.",
  transferIdRequired: "ID transfer diperlukan.",
  betTimeRequired: "Waktu taruhan diperlukan.",
  turnoverRequired: "Turnover diperlukan.",
  payoutRequired: "Pembayaran diperlukan.",
  winloseRequired: "Menang/Kalah diperlukan.",
  rawMessageRequired: "Pesan mentah diperlukan.",
  authStatusRequired: "Status asli diperlukan.",
  dateRequired: "Tanggal diperlukan.",
  betIdRequired: "ID taruhan diperlukan.",
  betStatusRequired: "Status taruhan diperlukan.",
  betAmountRequired: "Jumlah taruhan diperlukan.",
  isParlayRequired: "Apakah parlay diperlukan.",
  isAddonRequired: "Apakah tambahan diperlukan.",
  withholdBonusRequired: "Pemotongan bonus diperlukan.",
  withholdAmountRequired: "Jumlah pemotongan diperlukan.",
  maxWithdrawAmountRequired: "Jumlah penarikan maksimum diperlukan.",
  betTypeRequired: "Jenis taruhan diperlukan.",
  maxWithdrawMultipleRequired: "Kelipatan penarikan maksimum diperlukan.",
  socialPlatformRequired: "Platform sosial diperlukan.",
  vipProviderRebateRequired: "Rabat penyedia VIP diperlukan.",
  selfRebateRateRequired: "Tingkat rabat sendiri diperlukan.",
  downlineRebateRateRequired: "Tingkat rabat downline diperlukan.",
  tierIdRequired: "ID Tier diperlukan.",
  rebateRateRequired: "Tingkat rabat diperlukan.",
  paymentGatewayRequired: "Diperlukan gerbang pembayaran.",
  rescueIdRequired: "ID penyelamatan diperlukan.",
  rescueNameRequired: "Nama penyelamatan diperlukan.",
  rescueCycleRequired: "Siklus penyelamatan diperlukan.",
  minLoseRequired: "Diperlukan kerugian minimum.",
  rescueRateRequired: "Tingkat penyelamatan diperlukan.",
  maxPayoutRequired: "Pembayaran maksimum diperlukan.",
  payoutMethodRequired: "Metode pembayaran diperlukan.",
  targetGroupRequired: "Kelompok target diperlukan.",
  maintainDepositRequired: "Mempertahankan deposit diperlukan.",
  maintainTurnoverRequired: "Mempertahankan omset diperlukan.",
  depositOrTurnoverRequired: "Diperlukan deposit atau omset.",
  maintainDepositOrMaintainTurnoverRequired: "Mempertahankan deposit atau mempertahankan omset diperlukan.",
  vipListRequired: "Daftar VIP diperlukan.",
  gameNameRequired: "Nama permainan diperlukan.",
  claimTypeRequired: "Jenis klaim diperlukan.",
  operatorIdRequired: "ID operator diperlukan.",
  maxBonusRequired: "Bonus maksimum diperlukan.",
  endTimeRequired: "Waktu akhir diperlukan.",
  mondayRequired: "Hari Senin wajib.",
  tuesdayRequired: "Selasa wajib.",
  wednesdayRequired: "Rabu wajib.",
  thursdayRequired: "Kamis wajib.",
  fridayRequired: "Jumat wajib.",
  saturdayRequired: "Sabtu wajib.",
  sundayRequired: "Minggu wajib diisi.",
  promotionTypeRequired: "Jenis promosi diperlukan.",
  claimLimitRequired: "Batas klaim diperlukan.",
  bonusRate1Required: "Tingkat bonus 1 diperlukan.",
  bonusRate1To2Required: "Tingkat bonus 1 hingga 2 diperlukan.",
  bonusRate1To3Required: "Tingkat bonus 1 hingga 3 diperlukan.",
  bonusRate1To4Required: "Tingkat bonus 1 hingga 4 diperlukan.",
  bonusRate1To5Required: "Tingkat bonus 1 hingga 5 diperlukan.",
  bonusRate1To6Required: "Tingkat bonus 1 hingga 6 diperlukan.",
  bonusRate1To7Required: "Tingkat bonus 1 hingga 7 diperlukan.",
  externalIdRequired: "ID eksternal diperlukan.",
  opsiteRequired: "Diperlukan situs web.",
  opsiteContentRequired: "Konten situs web diperlukan.",
  opsiteLanguageRequired: "Bahasa situs web diperlukan.",
  opsitePaymentRequired: "Pembayaran situs web diperlukan.",
  opsiteProviderRequired: "Penyedia situs diperlukan.",
  opsiteProviderGamesRequired: "Permainan penyedia situs diperlukan.",
  accountTypeRequired: "Jenis akun diperlukan.",
  domainNameRequired: "Nama domain diperlukan.",
  settledTimeRequired: "Waktu penyelesaian diperlukan.",
  validTurnoverRequired: "Omset yang valid diperlukan.",
  resultTimeRequired: "Waktu hasil diperlukan.",
  resultStatusRequired: "Status hasil diperlukan.",
  secondIdRequired: "ID kedua diperlukan.",
  domainListRequired: "Daftar domain diperlukan.",
  domainTypeRequired: "Jenis domain diperlukan.",
  moduleRequired: "Modul diperlukan.",
  gameIdRequired: "ID game diperlukan.",
  gameDetailRequired: "Detail permainan diperlukan.",
  bonusRate1To8Required: "Tingkat bonus 1 hingga 8 diperlukan.",
  bonusRate1To9Required: "Tingkat bonus 1 hingga 9 diperlukan.",
  bonusRate1To10Required: "Tingkat bonus 1 hingga 10 diperlukan.",
  invalidOrder: "Pesanan tidak valid.",
  bannerNotExists: "Spanduk tidak ada.",
  invalidBannerType: "Jenis spanduk tidak valid.",
  pageNameExists: "Nama halaman ada.",
  pageNotExists: "Halaman tidak ada.",
  tacIsValid: "OTP valid.",
  invalidTac: "OTP tidak valid.",
  tacExpired: "OTP kedaluwarsa.",
  tacNotValidate: "OTP tidak tervalidasi.",
  paymentModeNotExists: "Mode pembayaran tidak ada.",
  paymentOptionProviderNotExists: "Penyedia opsi pembayaran tidak ada.",
  ipAddressExists: "Alamat IP ada.",
  ticketProcessed: "Tiket diproses.",
  bankAccountNotExists: "Rekening bank tidak ada.",
  bankAccountInactive: "Rekening bank tidak aktif.",
  bankMemberNotExists: "Anggota bank tidak ada.",
  bankMemberInactive: "Anggota bank tidak aktif.",
  affiliateExists: "Afiliasi ada.",
  contactPhoneExists: "Kontak telepon ada.",
  affiliateFull: "Afiliasi penuh.",
  uplineInactive: "Upline tidak aktif.",
  applicationProcessed: "Aplikasi diproses.",
  tacValidated: "Syarat dan ketentuan divalidasi.",
  applicationPending: "Permohonan tertunda.",
  favouriteGameExists: "Permainan favorit ada.",
  invalidLimit: "Batas tidak valid.",
  settingNotSet: "Pengaturan tidak ditetapkan.",
  domainNameNotExists: "Nama domain tidak ada.",
  domainNameFull: "Nama domain penuh.",
  domainNameNotAvailable: "Nama domain tidak tersedia.",
  domainNameExists: "Nama domain ada.",
  subAccountNotExists: "Sub-akun tidak ada.",
  settingNotExists: "Pengaturan tidak ada.",
  invalidContactEmail: "Email kontak tidak valid.",
  accountInactive: "Akun tidak aktif.",
  campaignNotExists: "Kampanye tidak ada.",
  paymentProviderNotExists: "Penyedia pembayaran tidak ada.",
  profileInactive: "Profil tidak aktif.",
  minWithdrawalNotMet: "Penarikan minimum tidak terpenuhi.",
  invalidBankId: "ID bank tidak valid.",
  bankAccountExists: "Rekening bank ada.",
  bankAccountFull: "Rekening bank penuh.",
  bankAccHolderNotSame: "Pemegang rekening bank tidak sama.",
  exceedMaxWithdrawal: "Melebihi penarikan maksimum.",
  exceedWithdrawalFrequency: "Melebihi frekuensi penarikan.",
  invalidPackage: "Paket tidak valid.",
  promotionNotAvailable: "Promosi tidak tersedia.",
  ongoingPromotion: "Promosi sedang berlangsung.",
  pendingResultInGame: "Hasil tertunda dalam permainan.",
  labelNameExists: "Nama label ada.",
  labelNotExists: "Label tidak ada.",
  invalidFtdMin: "Minimum deposit pertama kali tidak valid.",
  invalidFtdMax: "Maksimum setoran pertama kali tidak valid.",
  ftdMinGtFtdMax: "Minimum deposit pertama kali lebih besar dari maksimum.",
  vipFull: "VIP penuh.",
  invalidRewardType: "Jenis hadiah tidak valid.",
  vipExists: "VIP ada.",
  vipNotExists: "VIP tidak ada.",
  onlyOneMaxWithdrawSetting: "Hanya satu pengaturan penarikan maksimum yang diizinkan.",
  onlyOneWithholdSetting: "Hanya satu pengaturan penarikan yang diizinkan.",
  campaignExists: "Kampanye ada.",
  vipProviderNotExists: "Penyedia VIP tidak ada.",
  turnoverTierExists: "Tingkat omset ada.",
  turnoverTierFull: "Tingkat turnover melebihi tingkat maksimum.",
  turnoverTierNotExists: "Tingkat omset tidak ada.",
  invalidSettingValue: "Nilai pengaturan tidak valid.",
  turnoverTierNotSet: "Tingkat omset tidak ditetapkan.",
  rebateProcessed: "Rabat diproses.",
  invalidActionType: "Jenis tindakan tidak valid.",
  invalidRescueCycle: "Siklus penyelamatan tidak valid.",
  invalidPayoutMethod: "Metode pembayaran tidak valid.",
  invalidTargetGroup: "Kelompok target tidak valid.",
  rescueExists: "Penyelamatan ada.",
  rescueNotExists: "Penyelamatan tidak ada.",
  walletExists: "Dompet ada.",
  accountExists: "Akun ada.",
  activeFromGtActiveTo: "Aktif dari lebih besar dari aktif ke.",
  accountNotExists: "Operator ID tidak ada.",
  invalidDeposit: "Deposit tidak valid.",
  invalidTurnover: "Omset tidak valid.",
  providerCodeNotExists: "Kode operator tidak ada.",
  gameNameExists: "Nama permainan ada.",
  gameNameNotExists: "Nama permainan tidak ada.",
  invalidAccountType: "Jenis akun tidak valid.",
  invalidLoginIdFormat: "Format ID login tidak valid.",
  invalidReferralCode: "Kode referensi tidak valid.",
  firstDepositNotMet: "Setoran pertama tidak terpenuhi.",
  newbieNotMet: "Persyaratan pemula tidak terpenuhi.",
  claimPromoOnlyOnce: "Klaim promosi hanya sekali.",
  promotionRequirementNotMet: "Persyaratan promosi tidak terpenuhi.",
  withdrawalAmountLteWithholdAmount: "Jumlah penarikan kurang dari atau sama dengan jumlah pemotongan.",
  subAccountInactive: "Sub-akun tidak aktif.",
  gameNotSupported: "Permainan tidak didukung.",
  startTimeGteEndTime: "Waktu mulai lebih besar dari atau sama dengan waktu berakhir.",
  invalidPromotionType: "Jenis promosi tidak valid.",
  invalidClaimType: "Jenis klaim tidak valid.",
  claimLimitExceeded10: "Batas klaim melebihi 10.",
  verificationFailed: "Verifikasi gagal.",
  claimLimitReached: "Batas klaim tercapai.",
  invalidPromotion: "Promosi tidak valid.",
  socialPlatformExists: "Platform sosial ada.",
  duplicateReview: "Ulasan duplikat.",
  invalidSurveyId: "ID survei tidak valid.",
  accountNotBlock: "Akun tidak diblokir.",
  walletNotExists: "Dompet tidak ada.",
  socialPlatformNotExists: "Platform sosial tidak ada.",
  socialPlatformInactive: "Platform sosial tidak aktif.",
  accountSocialExists: "Akun sosial ada.",
  invalidStatus: "Status tidak valid.",
  samePassword: "Kata sandi yang sama.",
  invalidPassword: "Nama pengguna atau kata sandi tidak valid.",
  secondaryAccountExists: "Akun sekunder ada.",
  invalidSecurityCode: "Kode keamanan tidak valid.",
  accountSocialNotExists: "Akun sosial tidak ada.",
  providerInactive: "Penyedia tidak aktif.",
  gameIdExists: "Game ID ada.",
  gameIdNotExists: "ID game tidak ada.",
  parentProviderInactive: "Penyedia induk tidak aktif.",
  betLimitNotExists: "Batas taruhan tidak ada.",
  min3Characters: "Minimal 3 karakter.",
  invalidBankAccType: "Jenis rekening bank tidak valid.",
  senderBankNotExists: "Bank pengirim tidak ada.",
  recipientBankNotExists: "Bank penerima tidak ada.",
  affiliateNotExists: "Afiliasi tidak ada.",
  redepositedTicket: "Tiket disetor ulang.",
  invalidDepositType: "Jenis deposit tidak valid.",
  affiliateInactive: "Afiliasi tidak aktif.",
  bonusUnavailable: "Bonus tidak tersedia.",
  pendingDeposit: "Deposit tertunda.",
  noOngoingPromotion: "Tidak ada promosi yang sedang berlangsung.",
  iframeNotExists: "IFrame tidak ada.",
  gameMaintenance: "Pemeliharaan permainan.",
  labelInactive: "Label tidak aktif.",
  invalidDomainType: "Jenis domain tidak valid.",
  invalidModule: "Modul tidak valid.",
  labelFull: "Label penuh.",
  questionExists: "Pertanyaan ada.",
  questionFull: "Pertanyaan penuh.",
  questionNotExists: "Pertanyaan tidak ada.",
  reviewNotExists: "Ulasan tidak ada.",
  invalidDomainGroup: "Grup domain tidak valid.",
  invalidDateRange: "Rentang tanggal tidak valid.",
  ipAddressNotExists: "Alamat IP tidak ada.",
  marqueeNotExists: "Tenda tidak ada.",
  invalidAmount: "Jumlah tidak valid.",
  insufficientBalance: "Saldo tidak mencukupi.",
  minLimitLtParent: "Batas minimum kurang dari induk.",
  maxLimitGtParent: "Batas maksimum lebih besar dari induk.",
  startDateGtEndDate: "Tanggal mulai lebih besar dari tanggal akhir.",
  currencyNotExists: "Mata uang tidak ada.",
  currencyExists: "Mata uang ada.",
  noAccumulateWin: "Tidak ada akumulasi kemenangan.",
  invalidSession: "Sesi tidak valid.",
  sessionExpired: "Sesi berakhir.",
  promotionExists: "Promosi ada.",
  invalidCriteria: "Kriteria tidak valid.",
  promotionNotExists: "Promosi tidak ada.",
  ticketNotExists: "Tiket tidak ada.",
  duplicateDebitRecord: "Catatan debit duplikat.",
  duplicateCreditRecord: "Duplikat catatan kredit.",
  debitRecordNotExists: "Catatan debit tidak ada.",
  minDepositNotMet: "Deposit minimum tidak terpenuhi.",
  duplicateBet: "Taruhan duplikat.",
  invalidProviderCode: "Kode penyedia tidak valid.",
  resultExists: "Hasil ada.",
  unableSPProcess: "Sistem tidak dapat memproses permintaan Anda.",
  authRequired: "Kode otentikasi diperlukan.",
  domainExists: "Domain sudah ada.",
  multiSelectOption: "Silakan pilih {fname}",
  invalidDomainFormat: "Format Domain Tidak Valid",
  noHttpHttps: "'https://' atau 'http://' tidak diizinkan.",
  noReservedSubdomain: "Subdomain yang dicadangkan tidak diperbolehkan. Untuk penggunaan tautan unduhan aplikasi.",
  operatorInactive: "Operator tidak aktif",
  invalidAccountIdFormat: "Format ID Akun tidak valid",
  contentIdRequired: "ID menu diperlukan",
  themeCodeRequired: "Kode tema diperlukan",
  themeNameRequired: "Nama tema diperlukan",
  themeColorRequired: "Warna tema diperlukan",
  languageRequired: "Bahasa diperlukan",
  positionRequired: "Posisi diperlukan",
  themeContentIdRequired: "ID konten tema diperlukan",
  emailRequired: "Email diperlukan",
  themeProviderTypeRequired: "Jenis penyedia tema diperlukan",
  phoneRequired: "Telepon diperlukan",
  targetTypeRequired: "Jenis target diperlukan",
  packageTypeRequired: "Jenis paket diperlukan",
  renewTermRequired: "Jangka waktu perpanjangan diperlukan",
  packagePriceRequired: "Harga paket diperlukan",
  packageStatusRequired: "Status paket diperlukan",
  sortKeyRequired: "Kunci pengurutan diperlukan",
  invalidDomainStatus: "Status domain tidak valid",
  invalidCurrency: "Mata uang tidak valid",
  invalidThemeCode: "Kode tema tidak valid",
  invalidLanguage: "Bahasa tidak valid",
  invalidPosition: "Posisi tidak valid",
  invalidThemeContent: "Konten tema tidak valid",
  allParamsSameAsCurrent: "Tidak ada perubahan",
  invalidThemeColor: "Warna tema tidak valid",
  invalidCartStatus: "Status keranjang tidak valid",
  invalidThemeProviderType: "Jenis penyedia tema tidak valid",
  themeProviderTypeCannotBeUse: "Jenis penyedia tema tidak dapat digunakan",
  invalidUserStatus: "Status pengguna tidak valid",
  packageCannotBeRemove: "Paket tidak dapat dihapus",
  userStatusIsAlrdSuspend: "Pengguna sudah ditangguhkan",
  userStatusIsAlrdBlocked: "Pengguna sudah diblokir",
  userStatusIsAlrdActive: "Pengguna sudah aktif",
  invalidSortType: "Jenis pengurutan tidak valid",
  startDateBiggerThanEndDate: "Tanggal mulai lebih besar dari tanggal akhir",
  positionCannotBeUse: "Posisi tidak dapat digunakan",
  funcAddContentFailed: "Gagal menambahkan konten",
  funcDeleteContentFailed: "Gagal menghapus konten",
  funcUpdateContentFailed: "Gagal memperbarui konten",
  funcAddThemeFailed: "Gagal menambahkan tema",
  funcDeleteThemeFailed: "Gagal menghapus tema",
  funcUpdateThemeFailed: "Gagal memperbarui tema",
  funcAddThemeColorFailed: "Gagal menambahkan warna tema",
  funcDeleteThemeColorFailed: "Gagal menghapus warna tema",
  funcUpdateThemeColorFailed: "Gagal memperbarui warna tema",
  funcAddLanguageFailed: "Gagal menambahkan bahasa",
  funcDeleteLanguageFailed: "Gagal menghapus bahasa",
  funcUpdateLanguageFailed: "Gagal memperbarui bahasa",
  funcAddThemeContentFailed: "Gagal menambahkan konten tema",
  funcDeleteThemeContentFailed: "Gagal menghapus konten tema",
  funcUpdateThemeContentFailed: "Gagal memperbarui konten tema",
  funcAddContentPositionFailed: "Gagal menambahkan posisi konten",
  funcUpdateContentPositionFailed: "Gagal memperbarui posisi konten",
  funcDeleteContentPositionFailed: "Gagal menghapus posisi konten",
  funcAddThemeProviderTypeFailed: "Gagal menambahkan jenis penyedia tema",
  funcUpdateThemeProviderTypeFailed: "Gagal memperbarui jenis penyedia tema",
  funcDeleteThemeProviderTypeFailed: "Gagal menghapus jenis penyedia tema",
  funcAddPackageFailed: "Gagal menambahkan paket",
  funcUpdatePackageFailed: "Gagal memperbarui paket",
  funcDeletePackageFailed: "Gagal menghapus paket",
  nicknameRequired: "Nama panggilan diperlukan",
  accountStatusRequired: "Status akun diperlukan",
  contentIdMaxLength50: "Panjang maksimum ID menu adalah 50",
  positionMaxLength10: "Panjang maksimum posisi adalah 10",
  contentDescMaxLength200: "Panjang maksimum deskripsi konten adalah 200",
  domainStatusRequired: "Status domain diperlukan",
  funcAddDomainFailed: "Gagal menambahkan domain",
  funcUpdateDomainFailed: "Gagal memperbarui domain",
  uploadFailed: "Pengunggahan gagal!",
  sortKeyMaxLength50: "Panjang maksimum kunci pengurutan adalah 50",
  invalidSortTypeFormat: "Format jenis pengurutan tidak valid",
  invalidPackageId: "ID paket tidak valid",
  invalidAccountStatusFormat: "Format status akun tidak valid",
  invalidSiteStatusFormat: "Format status situs tidak valid",
  invalidPackageStatus: "Status paket tidak valid",
  invalidEmailFormat: "Format email tidak valid",
  invalidPhoneFormat: "Format telepon tidak valid",
  languageLengthNotInRange: "Panjang bahasa tidak berada dalam rentang (2-5)",
  languageDescriptionMaxLength50: "Panjang maksimal deskripsi bahasa adalah 50",
  remarkMaxLength500: "Panjang maksimal komentar adalah 500",
  themeProviderTypeMaxLength50: "Panjang maksimal jenis penyedia tema adalah 50",
  themeNameMaxLength50: "Panjang maksimal nama tema adalah 50",
  themeColorMaxLength20: "Panjang maksimal warna tema adalah 20",
  noSpace: "Tidak boleh mengandung spasi",
  packageDescEnRequired: "Nama dalam bahasa Inggris wajib diisi",
  packageDescEnMaxLength20: "Panjang maksimal nama bahasa Inggris adalah 20",
  allParamsIsNull: "Semua parameter adalah nol",
  contentCannotBeRemove: "Konten tidak dapat dihapus",
  contentDetailsRequired: "Detail konten diperlukan",
  domainCannotBeUse: "Domain tidak dapat digunakan",
  domainGroupMaxLength20: "Panjang maksimal grup domain adalah 20",
  domainGroupRequired: "Grup domain diperlukan",
  domainNameCannotUpdate: "Nama domain tidak dapat diperbarui",
  domainNameMaxLength400: "Panjang maksimal nama domain adalah 400",
  domainsRequired: "Domain diperlukan",
  domainStatusMaxLength20: "Panjang maksimal status domain adalah 20",
  domainTypeMaxLength10: "Panjang maksimal jenis domain adalah 10",
  funcAddThemeContentGroupFailed: "Tambah grup konten tema gagal",
  funcDeleteThemeContentGroupFailed: "Hapus grup konten tema gagal",
  funcOpsiteUpdateFailed: "Pembaruan situs web gagal",
  funcResetAccountPasswordFailed: "Reset kata sandi akun gagal",
  funcSiteLanguageUpsertFailed: "Pembaruan bahasa situs gagal",
  funcSiteThemeContentUpsertFailed: "Pembaruan konten tema situs gagal",
  funcSiteThemeUpsertFailed: "Pembaruan tema situs gagal",
  funcSiteUpdateFailed: "Pembaruan situs gagal",
  funcUpdateAccountFailed: "Pembaruan akun gagal",
  funcUpdateAccountStatusActiveFailed: "Pembaruan status akun menjadi aktif gagal",
  funcUpdateAccountStatusCompanyBlockFailed: "Pembaruan status akun ke blokir perusahaan gagal",
  funcUpdateAccountStatusSuspendFailed: "Update status akun ke suspend gagal",
  funcUpdateThemeContentGroupFailed: "Pembaruan grup konten tema gagal",
  invalidBoDomain: "Domain BO tidak valid",
  invalidOperatorIdFormat: "Format ID operator tidak valid",
  invalidOpsite: "Opsite tidak valid",
  invalidOpsiteOperator: "Operator situs web tidak valid",
  invalidOpsiteVersion: "Versi situs web tidak valid",
  invalidParentContentInGroup: "Konten induk tidak valid dalam grup",
  invalidSite: "Situs tidak valid",
  invalidSiteStatus: "Status situs tidak valid",
  invalidThemeContentGroup: "Grup konten tema tidak valid",
  languageCannotBeUse: "Bahasa tidak dapat digunakan",
  languagesRequired: "Bahasa diperlukan",
  logo1Required: "Logo diperlukan",
  notSupportMultiDefault: "Multi-default tidak didukung",
  operatorIdMaxLength50: "Panjang maksimal ID operator adalah 50",
  opsiteNotMatch: "Situs tidak cocok",
  packageTypeMaxLength15: "Panjang maksimal jenis paket adalah 15",
  parentContentIdCannotSameWithContentId: "ID konten induk tidak boleh sama dengan ID konten",
  phoneNumberRequired: "Nomor telepon diperlukan",
  siteIdRequired: "ID situs diperlukan",
  siteNameMaxLength50: "Panjang maksimal nama situs adalah 50",
  siteNameRequired: "Nama situs diperlukan",
  technicalError: "Kesalahan teknis",
  themeCannotBeRemove: "Tema tidak dapat dihapus",
  themeCodeCannotBeUse: "Kode tema tidak dapat digunakan",
  themeCodeMaxLength20: "Panjang maksimal kode tema adalah 20",
  themeColorCannotBeRemove: "Warna tema tidak dapat dihapus",
  themeColorCannotBeUse: "Warna tema tidak dapat digunakan",
  themeContentCannotBeUse: "Konten tema tidak dapat digunakan",
  themeContentGroupCannotBeUse: "Kelompok konten tema tidak dapat digunakan",
  themeContentGroupDescriptionMaxLength50: "Panjang maksimal deskripsi grup konten tema adalah 50",
  themeContentGroupMaxLength20: "Panjang maksimal grup konten tema adalah 20",
  themeContentGroupRequired: "Kelompok konten tema diperlukan",
  themeNameCannotBeUse: "Nama tema tidak dapat digunakan",
  userHaventVerifyThisBefore: "Pengguna belum pernah memverifikasi ini sebelumnya",
  isDefaultTrueRequired: "Bahasa harus memiliki 1 default",
  accountIdMaxLength50: "Panjang maksimal User ID adalah 50",
  headBodyScriptEitherOne: "Silakan masukkan Head Script atau Body Script",
  alphaOrNum: "Harus berupa alfabet atau angka saja",
  phoneValid: "Masukkan Nomor Telepon yang valid",
  permittedAmountRequired: "Jumlah yang diizinkan diperlukan",
  ignoreRiskRequired: "Abaikan risiko diperlukan",
  paymentDescRequired: "Deskripsi pembayaran diperlukan",
  gameTypeRequired: "Jenis permainan diperlukan",
  statusRequired: "Status diperlukan",
  payoutIdRequired: "Id Pembayaran diperlukan",
  commNotExists: "Komisi tidak ada",
  parentCommNotExists: "Komisi induk tidak ada",
  carryOverNotExists: "Carry over tidak ada",
  hotGameExists: "Permainan panas sudah ada",
  commSportsExceededParent: "Komisi untuk olahraga melebihi induk",
  commSlotsExceededParent: "Komisi untuk slot melebihi induk",
  commLivecasinoExceededParent: "Komisi untuk kasino langsung melebihi induk",
  commCockfightExceededParent: "Komisi untuk sabung ayam melebihi induk",
  commOthersExceededParent: "Komisi untuk yang lain melebihi induk",
  hotGameNotExists: "Permainan panas tidak ada",
  noSecurityDeposit: "Tidak ada dana keamanan",
  exchangeRateNotExists: "Nilai tukar tidak ada",
  insufficientSecurityDeposit: "Dana keamanan tidak mencukupi",
  duplicateDomain: "Domain duplikat",
  contactEmailNotExists: "Email kontak tidak ada",
  featuredGameNotExists: "Fitur permainan tidak ada",
  newGameNotExists: "Permainan baru tidak ada",
  popularGameNotExists: "Permainan populer tidak ada",
  featuredGameExists: "Permainan fitur sudah ada",
  newGameExists: "Permainan baru sudah ada",
  popularGameExists: "Permainan populer sudah ada",
  rebateNotExists: "Rabat tidak ada",
  riskyMember: "Anggota berisiko",
  ipRestricted: "IP dibatasi",
  notSupportedBank: "Bank tidak didukung.",
  requestTooFrequent: "Permintaan terlalu sering.",
  paymentOptionNotExists: "Opsi pembayaran tidak ada.",
  earningIdRequired: "ID Penghasilan diperlukan.",
  ptOnRequired: "PT On diperlukan.",
  ptRequired: "PT diperlukan.",
  userIdRequired: "ID Pengguna wajib diisi.",
  businessIdRequired: "ID Bisnis diperlukan.",
  subAccountIdRequired: "ID Sub Akun diperlukan.",
  sourceAccountIdRequired: "ID Akun Sumber diperlukan.",
  targetAccountIdRequired: "ID Akun Tujuan diperlukan.",
  ticketTaken: "Tiket sudah diambil",
  ticketNotTaken: "Tiket belum diambil",
  invalidPt: "PT tidak valid",
  topupIdRequired: "ID Top Up diperlukan",
  promotionMemberLogNotExists: "Log anggota promosi tidak ada",
  paymentOptionInactive: "Opsi Pembayaran Tidak Aktif",
  invalidCartStatusFormat: "Format status keranjang tidak valid",
  requestIncompleted: 'Permintaan Tidak Lengkap',
  unknownError: 'Terjadi kesalahan yang tidak diketahui',
  cartIdRequired: "ID Keranjang wajib diisi",
  stepNameRequired: "Nama langkah wajib diisi",
  invalidCart: "Keranjang tidak valid",
  invalidStepName: "Nama langkah tidak valid",
  cartHaventSetupComplete: "Keranjang belum selesai disiapkan",
  funcCartCreateFailed: "Gagal membuat keranjang",
  funcCartUpdateFailed: "Gagal memperbarui keranjang",
  funcSiteCreateFailed: "Gagal membuat situs",
  funcCartPurchasedUpdateFailed: "Gagal memperbarui status pembelian keranjang",
  invalidPasswordFormat: "Format kata sandi tidak valid",
  currencyCodeRequired: "Mata uang wajib diisi",
  funcCartLanguageUpsertFailed: "Gagal memperbarui bahasa keranjang",
  invalidUserIdFormat: "Format ID Pengguna tidak valid",
  operatorPasswordRequired: "Kata sandi operator wajib diisi",
  funcCartOperatorInfoUpsertFailed: "Gagal memperbarui informasi operator keranjang",
  invalidOperatorPasswordFormat: "Format kata sandi operator tidak valid",
  operatorIdCannotBeUse: "ID Operator tidak dapat digunakan",
  siteNameLengthNotInRange: "Panjang Nama Situs tidak sesuai",
  userIdCannotBeUse: "ID Pengguna tidak dapat digunakan",
  siteIdAlrdExist: "ID Situs sudah ada",
  operatorIdAlrdExist: "ID Operator sudah ada",
  externalIdAlrdExist: "ID Eksternal sudah ada",
  opsiteContentAlrdExist: "Konten tema situs sudah ada",
  opsiteLanguageAlrdExist: "Bahasa konten situs sudah ada",
  boAccountAlrdExist: "Akun BO sudah ada",
  boAccountProfileAlrdExist: "Profil akun BO sudah ada",
  boAccountLoginAlrdExist: "Login akun BO sudah ada",
  funcCartThemeCodeUpsertFailed: "Gagal memperbarui tema keranjang",
  funcCartThemeColorUpsertFailed: "Gagal memperbarui warna keranjang",
  funcOpsiteCreateFailed: "Gagal membuat konten situs",
  alphabetValid: "Harus memiliki setidaknya satu huruf besar dan satu huruf kecil",
  numberValid: "Harus memiliki setidaknya satu angka",
  symbolValid: "Harus memiliki setidaknya satu simbol",
  credentialNotSet: "Kredensial belum disetel",
  validBankAccFormat: "Format No. Rekening Bank tidak valid",
  moreThan: "{fname} harus kurang dari atau sama dengan {fname2}",
  lessThan: "{fname} harus lebih dari atau sama dengan {fname2}.",
  bankAccountNotAvailable: "Rekening bank tidak tersedia.",
  insufficientCredit: "Kredit Tidak Cukup",
  enableRequired: "Harus diaktifkan.",
  funcAddGameFailed: "Gagal menambahkan game.",
  funcAddGameRewardByBatchFailed: "Gagal menambahkan hadiah game secara batch.",
  funcAddGameRewardFailed: "Gagal menambahkan hadiah game.",
  funcAddGameTemplateFailed: "Gagal menambahkan template game.",
  funcAddLayoutTemplateFailed: "Gagal menambahkan template tata letak.",
  funcAddOperatorGameFailed: "Gagal menambahkan game operator.",
  funcAddOperatorMemberWalletFailed: "Gagal menambahkan dompet anggota operator.",
  funcDeleteGameFailed: "Gagal menghapus game.",
  funcDeleteGameRewardFailed: "Gagal menghapus hadiah game.",
  funcDeleteGameTemplateFailed: "Gagal menghapus template game.",
  funcDeleteLayoutTemplateFailed: "Gagal menghapus template tata letak.",
  funcDeleteOperatorGameFailed: "Gagal menghapus game operator.",
  funcUpdateGameFailed: "Gagal memperbarui game.",
  funcUpdateGameRewardFailed: "Gagal memperbarui hadiah game.",
  funcUpdateGameTemplateFailed: "Gagal memperbarui template game.",
  funcUpdateLayoutTemplateFailed: "Gagal memperbarui template tata letak.",
  funcUpdateOperatorGameFailed: "Gagal memperbarui game operator.",
  gameCannotBeRemove: "Game tidak dapat dihapus.",
  gameNameCannotBeUse: "Nama game tidak dapat digunakan.",
  gameNameMaxLength150: "Nama game maksimal 150 karakter.",
  gameRewardCannotBeUse: "Hadiah game tidak dapat digunakan.",
  gameRewardLimitExceeded: "Batas hadiah game terlampaui.",
  gameTemplateExist: "Template game sudah ada.",
  gameTypeMaxLength20: "Tipe game maksimal 20 karakter.",
  invalidGame: "Game tidak valid.",
  invalidGameReward: "Hadiah game tidak valid.",
  invalidGameTemplate: "Template game tidak valid.",
  invalidMemberWallet: "Dompet anggota tidak valid.",
  invalidOperatorGame: "Game operator tidak valid.",
  invalidRewardProbability: "Probabilitas hadiah tidak valid.",
  invalidTemplate: "Template tidak valid.",
  maxGameRewardRequired: "Hadiah game maksimum diperlukan.",
  maxMiniGameRewardRequired: "Hadiah mini-game maksimum diperlukan.",
  memberWalletAlrdExist: "Dompet anggota sudah ada.",
  operatorGameCannotBeUse: "Game operator tidak dapat digunakan.",
  operatorGameIdRequired: "ID game operator diperlukan.",
  rewardCodeMaxLength20: "Kode hadiah maksimal 20 karakter.",
  rewardCodeRequired: "Kode hadiah diperlukan.",
  rewardCurrencyMaxLength5: "Mata uang hadiah maksimal 5 karakter.",
  rewardCurrencyRequired: "Mata uang hadiah diperlukan.",
  rewardDescriptionMaxLength100: "Deskripsi hadiah maksimal 100 karakter.",
  rewardNameMaxLength50: "Nama hadiah maksimal 50 karakter.",
  rewardProbabilityRequired: "Probabilitas hadiah diperlukan.",
  rewardRequired: "Hadiah diperlukan.",
  selectedTemplateMaxLength30: "Template yang dipilih maksimal 30 karakter.",
  selectedTemplateRequired: "Template yang dipilih diperlukan.",
  success: "Sukses.",
  templateCannotBeRemove: "Template tidak dapat dihapus.",
  templateCodeCannotBeUse: "Kode template tidak dapat digunakan.",
  templateCodeMaxLength30: "Kode template maksimal 30 karakter.",
  templateCodeRequired: "Kode template diperlukan.",
  templateNameMaxLength50: "Nama template maksimal 50 karakter.",
  tokenRequestRequired: "Permintaan token diperlukan.",
  tokenRequired: "Token diperlukan.",
  mustMoreThan: "{fname} harus lebih dari {fvalue}.",
  mustMoreThanOrEqual: "{fname} harus lebih dari atau sama dengan {fvalue}.",
  tokenInvalid: "Input token tidak valid pada {key}",
  cashInvalid: "Input uang tunai tidak valid pada {key}",
  atLeastOneRequired: "Setidaknya satu diperlukan",
  cash1To7Required: "Cash 1 sampai 7 diperlukan",
  cash1To6Required: "Cash 1 sampai 6 diperlukan",
  cash1To5Required: "Cash 1 sampai 5 diperlukan",
  cash1To4Required: "Cash 1 sampai 4 diperlukan",
  cash1To3Required: "Cash 1 sampai 3 diperlukan",
  cash1To2Required: "Cash 1 sampai 2 diperlukan",
  cash1Required: "Cash 1 diperlukan",
  token1To7Required: "Token 1 sampai 7 diperlukan",
  token1To6Required: "Token 1 sampai 6 diperlukan",
  token1To5Required: "Token 1 sampai 5 diperlukan",
  token1To4Required: "Token 1 sampai 4 diperlukan",
  token1To3Required: "Token 1 sampai 3 diperlukan",
  token1To2Required: "Token 1 sampai 2 diperlukan",
  token1Required: "Token 1 diperlukan",
  cycleRequired: "Siklus diperlukan",
  targetAmountRequired: "Jumlah target diperlukan",
  gamifyIdRequired: "ID Hadiah diperlukan",
  gamifyMemberProcessed: "Member hadiah telah diproses",
  gamifyNotExists: "Hadiah tidak ditemukan",
  gamifyInactive: "Hadiah tidak aktif",
  invalidCycle: "Siklus tidak valid",
  memberIdMaxLength50: "ID Anggota tidak boleh lebih dari 50 karakter",
  funcAddGameWalletFreeCreditFailed: "Gagal menambahkan kredit gratis ke dompet permainan",
  funcUpdateOperatorMemberWalletBalanceFailed: "Gagal memperbarui saldo dompet anggota operator",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Gagal memperbarui saldo dompet anggota operator berdasarkan jumlah yang dibekukan",
  mustHaveBothAlphaNumOnly: "Gunakan hanya huruf dan angka, minimal satu dari masing-masing.",
  setupGameRewardBeforeEnable: "Silakan atur hadiah permainan sebelum mengaktifkannya.",
  rewardProbabilityMustNotAllZero: "Probabilitas hadiah tidak boleh semuanya nol.",
  totalRewardProbabilityCannotOver100: "Total probabilitas hadiah tidak boleh melebihi 100.",
  credential1To2Required: "Kredensial 1 hingga 2 wajib diisi.",
  credential1To4Required: "Kredensial 1 hingga 4 wajib diisi.",
  newRemarkRequired: "Keterangan wajib diisi.",
  notSupportedWithdrawalPG: "Gerbang pembayaran penarikan yang tidak didukung.",
  prizeInvalid: "Input hadiah tidak valid di {key}",
  exceedMaxCampaignCount: "Melebihi jumlah kampanye maksimum di papan peringkat.",
  leaderboardCampaignEnded: "Kampanye papan peringkat telah berakhir.",
  leaderboardCampaignStarted: "Kampanye papan peringkat dimulai",
  leaderboardCampaignSettled: "Kampanye papan peringkat selesai",
  pleaseSelectUpToNoPhone: "Silakan pilih hingga {fname} nomor telepon.",
  phoneNotAvailable: "Telepon tidak tersedia.",
  batchExpired: "Batch kedaluwarsa.",
  remarkNotSame: "Keterangan tidak cocok",
  partnerIdRequired: "ID mitra diperlukan",
  partnerNotExists: "Mitra tidak ada",
  urgencyRequired: "Urgensi diperlukan",
  groupSizeRequired: "Ukuran grup diperlukan",
  inactiveDaysRequired: "Hari tidak aktif diperlukan",
  idRequired: "ID diperlukan",
  expiryRequired: "Tanggal kedaluwarsa diperlukan",
  batchIdRequired: "ID batch diperlukan",
  requestDateRequired: "Tanggal permintaan diperlukan",
  requestByRequired: "Pemohon diperlukan",
  cpiIdRequired: "ID CPI diperlukan",
  assigneeRequired: "Penerima tugas diperlukan",
  phoneNotAvailable: "Telepon tidak tersedia",
  liveChatNotExists: "Obrolan langsung tidak ada",
  resultNotExists: "Hasil tidak ada",
  lastLaunchFundTransfer: "Transfer dana peluncuran terakhir",
  alreadyRegistered: "Sudah terdaftar",
  invalidId: "ID tidak valid",
  batchExpired: "Batch kedaluwarsa",
  teleCalling: "Panggilan telepon",
  invalidUrgency: "Urgensi tidak valid",
  appTypeRequired: "Jenis aplikasi diperlukan",
  invalidAppType: "Jenis aplikasi tidak valid",
  appLinkRequired: "Tautan aplikasi diperlukan",
  invalidDomain: "Domain tidak valid",
  existEndDateGtEndDate: "Tanggal akhir yang ada lebih lambat dari tanggal akhir baru",
  newRemark2Required: "Keterangan 2 baru diperlukan",
  remark2NotSame: "Keterangan 2 tidak cocok",
  remark2Required: "Keterangan 2 diperlukan",
  nameRequired: "Nama diperlukan",
  aiAssistantNotExists: "Asisten AI tidak ada",
  aiAssistantInactive: "Asisten AI tidak aktif",
  phoneStartWithVND: "Nomor telepon harus dimulai dengan 84",
  otherActiveLiveChat: "Ada LiveChat lain yang aktif",
  whiteLabelRequired: "White Label diperlukan",
  invalidWhiteLabel: "White Label tidak valid",
  baseRateDepositRequired: "Diperlukan suku bunga dasar deposit",
  revisionRequired: "Revisi diperlukan",
  typeDescRequired: "Deskripsi tipe diperlukan",
  riskWeightRequired: "Bobot risiko diperlukan",
  linkageTypeRequired: "Jenis keterkaitan diperlukan",
  valueRequired: "Nilai diperlukan",
  baseRateWithdrawalRequired: "Diperlukan suku bunga dasar penarikan",
  sourceIdRequired: "ID sumber diperlukan",
  targetIdRequired: "ID target diperlukan",
  linkageTypeNotExists: "Jenis keterkaitan tidak ada",
  phoneStartWithMYR: "Nomor telepon harus dimulai dengan 60",
  minWithdrawalAmount100: "Jumlah penarikan minimum adalah 100",
  invalidReward: "Reward tidak valid",
  noRow: "Tidak ada baris",
  credentialRequired: "Kredensial diperlukan",
  settlementIdRequired: "ID Settlement diperlukan",
  settlementDateRequired: "Tanggal settlement diperlukan",
  newCryptoAddressRequired: "Alamat kripto baru diperlukan",
  cryptoAddressRequired: "Alamat kripto diperlukan",
  settlementTypeRequired: "Tipe settlement diperlukan",
  chatProviderRequired: "Provider chat diperlukan",
  countRequired: "Jumlah diperlukan",
  voucherCodeRequired: "Kode voucher diperlukan",
  eventTypeRequired: "Tipe event diperlukan",
  viewTypeRequired: "Tipe tampilan diperlukan",
  actionTypeRequired: "Tipe aksi diperlukan",
  thresholdRequired: "Ambang batas diperlukan",
  missionIdRequired: "ID misi diperlukan",
  ruleIdRequired: "ID rule diperlukan",
  aggregatorRequired: "Aggregator diperlukan",
  rebateIdRequired: "ID rebate diperlukan",
  liveChatExists: "Livechat sudah ada",
  triggerNotExists: "Trigger tidak ada",
  missionRuleNotExists: "Rule misi tidak ada",
  invalidVoucherCode: "Kode voucher tidak valid",
  invalidRebateType: "Tipe rebate tidak valid",
  invalidSettlementType: "Tipe settlement tidak valid",
  missionNotExists: "Misi tidak ada",
  settlementTypeNotExists: "Tipe settlement tidak ada",
  parentTriggerInactive: "Trigger induk tidak aktif",
  parentMissionInactive: "Misi induk tidak aktif",
  missionRuleNotSet: "Rule misi belum diset",
  invalidCreditType: "Tipe kredit tidak valid",
  cryptoDisabled: "Kripto dinonaktifkan",
  depositExists: "Deposit sudah ada",
  parentSettlementTypeNotExists: "Tipe settlement induk tidak ada",
  accessControlNotExists: "Access control tidak ada",
  cryptoAccountFull: "Akun kripto penuh",
  cryptoAccountExists: "Akun kripto sudah ada",
  cryptoAccountNotExists: "Akun kripto tidak ada",
  settlementNotAvailable: "Settlement tidak tersedia",
  settlementProcessed: "Settlement diproses",
  cryptoAccountInactive: "Akun kripto tidak aktif",
  leadIdRequired: "ID lead diperlukan",
  failedToCreateFreeRound: "Gagal membuat free round.",
  failedToGetFreeRound: "Gagal mendapatkan free round.",
  failedToGetFreeRoundGameList: "Gagal mendapatkan daftar game free round.",
  tierFull: "Tier Penuh",
  tierNotExists: "Tier tidak ada",
  ticketTypeRequired: "Tipe Ticket wajib diisi",
  invalidTicketType: "Tipe Ticket tidak valid",
  positionRequired: "Posisi wajib diisi",
  invalidPosition: "Posisi tidak valid",
  invalidBonusRate: "Bonus Rate tidak valid",
  minRequired: "Nilai minimum wajib diisi",
  maxRequired: "Nilai maksimum wajib diisi",
  minGtMax: "Nilai minimum lebih besar dari maksimum.",
  sessionExists: "Sesi sudah ada",
  sessionOverlaps: "Sesi bertumpang tindih",
  sessionIdRequired: "ID Sesi wajib diisi",
  sessionNotExists: "Sesi tidak ada",
  nameExists: "Nama sudah ada",
  sessionElapsed: "Sesi telah berakhir",
  validUrl: "Silakan masukkan URL yang valid",
  minBalanceNotMet: "Saldo minimum belum terpenuhi",
  validSlugFormat: "Format slug tidak valid",

  failedToCancelFreeRound: "Gagal membatalkan putaran gratis.",
  failedToGetFreeRoundLineBet: "Gagal mendapatkan taruhan baris putaran gratis.",
};